import "@scss/index";
import { ScrollObserver } from "./libs/intersectionobserver";
import { TextAnimation } from "./libs/text-animation";
import("@scss/async/_module");
import("@scss/async/_parts");

/* eslint-disable */
document.addEventListener("DOMContentLoaded", function () {
  const main = new Main();
});
/* eslint-enable */

export class Main {
  constructor() {
    this._observers = [];
    this.header = document.querySelector(".header");
    this._init();
    this._click();
  }

  set observers(val) {
    this._observers.push(val);
  }

  get observers() {
    return this._observers;
  }

  _init() {
    this._scrollInit();
  }

  /* scrollで監視しactiveを追加 */
  _inviewAnimation(el, inview) {
    if (inview) {
      el.classList.add("inview");
    } else {
      el.classList.remove("inview");
    }
  }

  _textAnimation(el, inview) {
    if (inview) {
      const ta = new TextAnimation(el);
      ta.animate();
    }
  }

  _click() {
    const deleteBtn = document.querySelector(".top-contact__delete");
    const contactBody = document.querySelector(".top-contact__box.sp");
    deleteBtn.addEventListener("click", function () {
      contactBody.classList.add("d-none");
    });
  }

  _scrollInit() {
    this._observers.push(
      new ScrollObserver(".appear", this._inviewAnimation),
      new ScrollObserver(".cover-slide", this._inviewAnimation),
      new ScrollObserver(".animate-title", this._textAnimation)
    );
  }
}
